import { render, staticRenderFns } from "./studentBinding.vue?vue&type=template&id=3e67bc6d&scoped=true&"
import script from "./studentBinding.vue?vue&type=script&lang=js&"
export * from "./studentBinding.vue?vue&type=script&lang=js&"
import style0 from "./studentBinding.vue?vue&type=style&index=0&id=3e67bc6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e67bc6d",
  null
  
)

export default component.exports